<template>
  <div class="home">
    <Welcome/>
  </div>
</template>

<script>
import Welcome from '../components/Welcome.vue'

export default {
  name: 'Welcome',
  components: {
    Welcome,
  },
}
</script>
